export default "__VITE_ASSET__COu_EPsu__"